<template>
  <div>
    <template v-for="(item, index) in myitem">
      <!-- 因为有子集和无子集渲染html标签不一样，所以要分为两种情况
           情况一：有子集的情况：                         -->
      <el-submenu class="el-menu-vertical-demo"
        :key="index"
        :index="item.path"
        v-if="item.children.length > 0"
      >
        <template slot="title">
          <i :class="item.icon"></i>
          <span>{{ item.name }}</span>
        </template>
        <myitem :data="item.children"></myitem>
      </el-submenu>
      <!-- 情况二：没子集的情况： -->
      <el-menu-item :key="index" v-else :index="item.path">
        <i :class="item.icon"></i>
        <span slot="title">{{ item.name }}</span>
      </el-menu-item>
    </template>
  </div>
</template>

<script>
export default {
  name: "myitem",
  props: {
    data: {
      type: Array,
    },
    
  },
    data() {

    return {
      myitem: [
        {
          // 注意！注意！有children的菜单项，path不会使用的，所以path为什么都无所谓；没children的，即children的length等于0的，才会使用path属性做路由跳转
          name: "个人中心",
          path: "/user",
          icon: "el-icon-user-solid",
          children: [],
        },
        {
          name: "logo订单",
          path: "/order",
          icon: "el-icon-s-order",
          children: [],
        },
        {
          name: "我的收藏",
          path: "/collect",
          icon: "el-icon-picture",
          children: [],
        },
        {
          name: "我的足迹",
          path: "/view",
          icon: "el-icon-s-help",
          children: [],
        },
      ],
    };
  },
  // 注意： 在template标签上使用v-for，:key="index"不能写在template标签上，因为其标签不会被渲染，会引起循环错误
};
</script>


// WEBPACK FOOTER //
// src/components/myitem.vue